import Vue from 'vue'
import LayoutMainInner from '@/components/layout/layout-main-inner'
import LayoutCardWrap from '@/components/layout/layout-card-wrap'
import LinkRoute from '@/components/public/link-route'
import PaginationNew from '@/components/pagination-new.vue'
import UploadNew from '@/components/upload-new.vue'
import Empty from '@/components/public/empty'
const components = [LayoutMainInner, LayoutCardWrap, LinkRoute, PaginationNew, UploadNew, Empty]

components.forEach(component => {
  Vue.component(component.name, component)
})
